import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createRegion, resetFilters } from "../redux/regionsSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import { ErrorList } from "./ErrorList";
import { useError } from "../hooks/useError";
import { Filters } from "./Filters";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const Add = ({ isOpen, onClose, locations }) => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [selectedLocations, setSelectedLocations] = useState([]);

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const { errors, status } = useError(close);

  const save = () => {
    dispatch(createRegion({ name, locations: selectedLocations }));
  };

  const primaryButtonDisabled = !(name && name.trim() && status !== "pending");

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        parentSelector=".regions"
        headerText="Add Region"
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonClass="primary"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={save}
        secondaryBtnText="Cancel"
        secondaryBtnClass="secondary"
        secondaryBtnHandler={close}
        height={300}
        width={900}
        isAdminPanel={false}
      >
        <>
          <Filters
            name={name}
            onInputChange={setName}
            locations={locations}
            selectedLocations={selectedLocations}
            onSelectChange={setSelectedLocations}
          />
        </>
        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
